/* pdp-content.js – Besitzer: Agent «Inhalt». Kleine Verbesserungen für die Beschreibungs-Module.
   Alles funktioniert auch ohne dieses Skript (details/summary sind nativ bedienbar). */
(function () {
  'use strict';

  function openForHash() {
    var id = decodeURIComponent((location.hash || '').slice(1));
    if (!id) return;
    var target = document.getElementById(id);
    var d = target && target.closest ? target.closest('details.pdpc-q') : null;
    if (d) d.open = true;
  }

  function init() {
    var root = document.querySelector('[data-pdpc]');
    if (!root) return;
    openForHash();
    window.addEventListener('hashchange', openForHash);
    // Suche im Seitentext (Strg+F) öffnet geschlossene Fragen bereits nativ; für ältere Browser:
    root.addEventListener('beforematch', function (e) {
      var d = e.target && e.target.closest ? e.target.closest('details.pdpc-q') : null;
      if (d) d.open = true;
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
